import { Navigate, Outlet } from "react-router-dom";
import { useSelector } from "react-redux";
import { getRoleHome, isAllowedRole } from "./PermissionType";

const AuthType = ({ allowedRoles }) => {
  const authSelector = useSelector((state) => state.auth.auth);

  if (isAllowedRole(authSelector.role, allowedRoles)) {
    return <Outlet />;
  }

  if (authSelector.id) {
    return <Navigate to={getRoleHome(authSelector.role)} replace />;
  }

  return <Navigate to="/Login" replace />;
};

export default AuthType;
